import { OptionProps, components } from 'react-select';
import React from 'react';

interface BannerStyleOptionType {
    value: number;
    label: string;
}

export function BannerStyleOption(props: OptionProps<BannerStyleOptionType, false>) {
    return (
        <components.Option {...props}>
            <div className={`alert alert-${props.data.label.toLowerCase()} py-2 px-3 mb-0`}>
                {props.data.label}
            </div>
        </components.Option>
    );
}
